'use client';
import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { db } from '../../firebaseConfig'; // adjust path as needed
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      emailjs
        .send(
          'your_service_id',
          'your_template_id',
          formData,
          'your_public_key'
        )
        .catch(err => {
          console.warn('EmailJS failed silently:', err);
        });

      alert('Your contact information has been sent!');
      setFormData({
        name: '',
        email: '',
        phone: '',
      });
    } catch (error) {
      console.error('Firebase submission failed:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"
    >
      <div className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Name</label>
          <input
            type="text"
            name="name"
            className="cs_form_field"
            placeholder="David John"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Email</label>
          <input
            type="email"
            name="email"
            className="cs_form_field"
            placeholder="example@gmail.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">Phone</label>
          <input
            type="tel"
            name="phone"
            className="cs_form_field"
            placeholder="(123) 456-7890"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <div className="cs_height_18" />
          <button type="submit" className="cs_btn cs_style_1">
            <span>Submit</span>
            <i>
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
            </i>
          </button>
        </div>
      </div>
    </form>
  );
}
